import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { Filter } from "lucide-react";

import CommonFilter from "../../common/CommonFilter";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { saveAdvancedSelectedFilters } from "../../actionCreator/executiveListingActionCreater";
import { Col, Collapse, Row, Tag } from "antd";
import {
  Info as InfoIcon,
  Layers as ClassificationIcon,
  MapPin as LocationIcon,
  Globe as CountriesIcon,
  Map as StatesIcon,
  Building as CityIcon,
  Factory as IndustryIcon,
  Building2 as CompanyTypeIcon,
  Users as EmployeeIcon,
  DollarSign as RevenueIcon,
  Tag as TagIcon,
  UserCheck as ExecutivesIcon,
  ChevronUp as UpIcon,
  ChevronDown as DownIcon,
  Save,
  Briefcase,
  Network,
} from "lucide-react";

const EXCLUDED_KEYS = ["page", "size", "status"];
const splitValues = (value = "") =>
  value
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);

const AdvancedFilter = ({
  isModal,
  isImport,
  openAdvancedModel,
  showCheckAll = true,
  setOpenAdvancedModel,
  showNumberofRecords = null,
  isShow,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const companyFilterList = useSelector(
    (state) => state.executiveListingReducer,
  );

  const companySelectedFilterList = useSelector(
    (state) => state.executiveListingReducer.selectedFilters,
  );

  const companyFilterListIndustry = useSelector(
    (state) => state.executiveListingReducer.industryList,
  );

  const companyFilterListCompanyType = useSelector(
    (state) => state.executiveListingReducer.companyTypeList,
  );

  const companyFilterListEmployeeCountList = useSelector(
    (state) => state.executiveListingReducer.employeeCountList,
  );

  const companyFilterListRevenueRangeList = useSelector(
    (state) => state.executiveListingReducer.revenueRangeList,
  );

  const companyFilterListCities = useSelector(
    (state) => state.executiveListingReducer.geoLocation?.cities,
  );
  const companyFilterListCountries = useSelector(
    (state) => state.executiveListingReducer.geoLocation?.countries,
  );
  const companyFilterListStates = useSelector(
    (state) => state.executiveListingReducer.geoLocation?.states,
  );

  const companyFilterListSavedSearch = useSelector(
    (state) => state.executiveListingReducer.saveSearchList,
  );

  const companyFilterListTags = useSelector(
    (state) => state.DashboardReducer.executiveTags,
  );

  const executiveFilterFunctionList = useSelector(
    (state) => state.executiveListingReducer.executiveFunctionList,
  );

  const executiveFilterLevelList = useSelector(
    (state) => state.executiveListingReducer.executiveLevelList,
  );
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [visibleFilter, setVisibleFilter] = useState({
    country: false,
    state: false,
    city: false,
    industry: false,
    companyType: false,
    employeeCount: false,
    revenue: false,
    savedSearch: false,
    companyTag: false,
    executiveFunction: false,
    executiveLevel: false,
  });
  const [selectedCountryList, setSelectedCountryList] = useState([]);
  const [selectedStateList, setSelectedStateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [active, setActive] = useState(
    isModal ? (isImport ? ["location"] : ["executive-info"]) : (isImport ? ["location"] : []),
  );

  useEffect(() => {
    const allParams = {};
    for (const [key, value] of searchParams.entries()) {
      allParams[key] = value;
    }
    dispatch(
      saveAdvancedSelectedFilters({
        selectedExecutiveFunction: allParams?.["Executive Function"],
        selectedExecutiveLevel: allParams?.["Executive Level"],
        selectedCountry: allParams?.Countries?.split(","),
        selectedState: allParams?.States?.split(","),
        selectedCity: allParams?.Cities?.split(","),
        selectedIndustry: allParams?.Industry?.split(","),
        selectedCompanytype: allParams?.["Company Type"]?.split(","),
        selectedEmployeecount: allParams?.["Employee Count"]?.split(","),
        selectedRevenuerange: allParams?.["Revenue Range"]?.split(","),
        searchKeyword: allParams?.searchKeyword,
        selectedCompanyTag: allParams?.Tags?.split(","),
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!selectedStateList?.length) {
      setCitiesList(
        selectedCountryList?.length
          ? companyFilterList?.geoLocation?.cities.filter((city) => {
              return selectedCountryList
                ?.map((d) => ({
                  ...companyFilterList?.geoLocation?.countries?.find(
                    (i) => i?.name === d,
                  ),
                }))
                ?.some((ct) => {
                  return ct?.country_id === city?.country_id;
                });
            })
          : companyFilterList?.geoLocation?.cities,
      );
    } else {
      const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
        return selectedStateList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.states?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          });
      });
      setCitiesList(cityList);
    }
  }, [selectedStateList]);

  useEffect(() => {
    if (!selectedCountryList?.length) {
      setStatesList(companyFilterList?.geoLocation?.states);
    } else {
      //By Nawedita
      const cityList = companyFilterList?.geoLocation?.states.filter((city) => {
        return selectedCountryList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.countries?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return ct.country_id === city?.country_id;
          });
      });
      setStatesList(cityList);
    }
  }, [selectedCountryList]);

  useEffect(() => {
    setCitiesList(companyFilterListCities);
  }, [companyFilterListCities]);

  useEffect(() => {
    setStatesList(companyFilterListStates);
  }, [companyFilterListStates]);

  useEffect(() => {
    setSelectedCountryList(companySelectedFilterList?.selectedCountry);
    setSelectedStateList(companySelectedFilterList?.selectedState);
  }, [companySelectedFilterList]);

  const openVisibleFilter = (menu) => {
    setVisibleFilter({
      ...{
        country: false,
        state: false,
        city: false,
        industry: false,
        companyType: false,
        employeeCount: false,
        revenue: false,
        utility: false,
        pages: false,
        savedSearch: false,
        companyTag: false,
        executiveFunction: false,
        executiveLevel: false,
      },
      [menu]: !visibleFilter[menu],
    });
  };

  const onCountriesChange = (list) => {
    updateStateBasedOnCountry(list);
  };

  const updateStateBasedOnCountry = (list) => {
    const stateList = companyFilterList?.geoLocation?.states.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.states;
    });

    setStatesList(stateList);

    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct?.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.cities;
    });
    setCitiesList(cityList);
  };

  const filterCountry = (ele) => {
    setSelectedCountryList([]);
  };

  /*Countries Start */
  const showCountriesList = () => {
    return (
      <CommonFilter
        isModal={isModal}
        title="Countries"
        icon={<CountriesIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListCountries}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        onDataChange={onCountriesChange}
        onSearch={filterCountry}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("country")}
        isShow={isShow ? isShow : visibleFilter.country}
      />
    );
  };

  /*Countries End */

  /*State Start */
  const showStatesList = () => {
    return (
      <CommonFilter
        title="States"
        isModal={isModal}
        icon={<StatesIcon size={16} className="tw-text-slate-500" />}
        dataList={statesList}
        onSearch={filterState}
        onDataChange={onStatesChange}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("state")}
        isShow={isShow ? isShow : visibleFilter.state}
      />
    );
  };

  const filterState = (ele) => {
    setSelectedStateList([]);
  };

  const onStatesChange = (list) => {
    updateCityBasedOnState(list);
  };

  const updateCityBasedOnState = (list) => {
    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          })
        : companyFilterList?.geoLocation?.cities;
    });
    setCitiesList(cityList);
  };

  /*state End */

  /* City Start */
  const showCitiesList = () => {
    return (
      <CommonFilter
        title="Cities"
        isModal={isModal}
        icon={<CityIcon size={16} className="tw-text-slate-500" />}
        dataList={citiesList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("city")}
        isShow={isShow ? isShow : visibleFilter.city}
      />
    );
  };

  /*City End */

  /*Industry Start */
  const showIndustryList = () => {
    return (
      <CommonFilter
        title="Industry"
        isModal={isModal}
        icon={<IndustryIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListIndustry}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("industry")}
        isShow={isShow ? isShow : visibleFilter.industry}
      />
    );
  };

  /*Industry End */

  /*start companytype */
  const showCompanyTypeList = () => {
    return (
      <CommonFilter
        title="Company Type"
        isModal={isModal}
        icon={<CompanyTypeIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListCompanyType}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("companyType")}
        isShow={isShow ? isShow : visibleFilter.companyType}
      />
    );
  };

  /*End companytype */

  /*start employee count */
  const showEmployeeCountList = () => {
    return (
      <CommonFilter
        title="Employee Count"
        isModal={isModal}
        icon={<EmployeeIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListEmployeeCountList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("employeeCount")}
        isShow={isShow ? isShow : visibleFilter.employeeCount}
      />
    );
  };

  /*End employee count */

  /*Start revenue range */
  const showRevenueRangeList = () => {
    return (
      <CommonFilter
        title="Revenue Range"
        isModal={isModal}
        icon={<RevenueIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListRevenueRangeList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("revenue")}
        isShow={isShow ? isShow : visibleFilter.revenue}
      />
    );
  };

  /*End revenue range */

  /*Start Search List */
  const showSaveSearchList = () => {
    return (
      <CommonFilter
        title="Saved Search"
        isModal={isModal}
        icon={<Save size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListSavedSearch?.map((d) => ({
          ...d,
          name: d?.fullName,
        }))}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={false}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("savedSearch")}
        isShow={isShow ? isShow : visibleFilter.savedSearch}
      />
    );
  };

  /*End Search List */

  /*Start Company Tag List */
  const showExecutiveTagList = () => {
    return (
      <CommonFilter
        title="Tags"
        isModal={isModal}
        icon={<TagIcon size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListTags}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("companyTag")}
        isShow={isShow ? isShow : visibleFilter.companyTag}
      />
    );
  };

  /*End Company Tags List */

  /*Executive Function Start */
  const showExecutiveFunctionList = () => {
    return (
      <CommonFilter
        title="Executive Function"
        isModal={isModal}
        icon={<Briefcase size={16} className="tw-text-slate-500" />}
        dataList={executiveFilterFunctionList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("executiveFunction")}
        isShow={isShow ? isShow : visibleFilter.executiveFunction}
      />
    );
  };

  /*Executive Function End */

  /*Executive Level Start */
  const showExecutiveLevelList = () => {
    return (
      <CommonFilter
        title="Executive Level"
        isModal={isModal}
        icon={<Network size={16} className="tw-text-slate-500" />}
        dataList={executiveFilterLevelList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("executiveLevel")}
        isShow={isShow ? isShow : visibleFilter.executiveLevel}
      />
    );
  };

  const renderMap = {
    Countries: { id: "county", component: showCountriesList },
    States: { id: "state", component: showStatesList },
    Cities: { id: "city", component: showCitiesList },
    Industry: { id: "industry", component: showIndustryList },
    "Executive Function": {
      id: "execFunction",
      component: showExecutiveFunctionList,
    },
    "Executive Level": { id: "execLevel", component: showExecutiveLevelList },
    "Company Type": { id: "companyType", component: showCompanyTypeList },
    "Employee Count": { id: "emplyeeCount", component: showEmployeeCountList },
    "Revenue Range": { id: "revenueRange", component: showRevenueRangeList },
    "Saved Search": { id: "savedsearch", component: showSaveSearchList },
    Tags: { id: "companyTag", component: showExecutiveTagList },
  };

  const onFilterChange = (key, val) => {
    if (val !== undefined) {
      searchParams.set(key, val);
    } else {
      searchParams.delete(key);
    }
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const allParams = useMemo(() => {
    return Object.fromEntries(
      [...searchParams.entries()].filter(
        ([key]) => !EXCLUDED_KEYS.includes(key),
      ),
    );
  }, [searchParams]);

  const hasOtherFilters = Object.keys(allParams).length > 0;

  const formatValue = (key, value) => {
    const ids = splitValues(value);

    switch (key) {
      case "Revenue Range":
        return companyFilterListRevenueRangeList
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      case "Company Type":
        return companyFilterListCompanyType
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      case "Employee Count":
        return companyFilterListEmployeeCountList
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      case "Industry":
        return companyFilterListIndustry
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      case "Executive Function":
        return executiveFilterFunctionList
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      case "Executive Level":
        return executiveFilterLevelList
          ?.filter((d) => ids.includes(d.id.toString()))
          ?.map((d) => d.name)
          .join(", ");

      default:
        return value;
    }
  };

  const renderJsx = () => {
    const model = renderMap[openAdvancedModel.key];
    if (model) {
      return (
        <div className="filterblk" id={model.id}>
          {model.component()}
        </div>
      );
    }

    // Render all filters if no specific key is selected
    return (
      <>
        {isModal ? (
          <Row
            className={`${isImport ? "" : "tw-bg-white tw-border-t tw-border-b tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-100"} `}
          >
            <Col
              xs={8}
              className={`tw-p-4 ${isImport ? "" : "tw-bg-slate-50/50 tw-border-t-0 tw-border-b-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-slate-100 tw-font-inter"}`}
            >
              <div className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400 tw-mb-2">
                Filter Categories
              </div>
              <div
                className={`tw-flex tw-flex-col tw-gap-1.5 ${isImport ? "tw-border tw-border-solid tw-rounded-[10px] tw-p-4 tw-border-slate-200" : ""}`}
              >
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("location") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["location"]);
                  }}
                >
                  <div className="tw-flex tw-items-center tw-gap-2.5">
                    <LocationIcon size={16} className={active?.includes("location") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                    Location
                  </div>
                  {isImport && <span className="tw-text-red-500 tw-font-bold tw-text-xs" title="Contains mandatory filters">*</span>}
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("executive-info") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["executive-info"]);
                  }}
                >
                  <div className="tw-flex tw-items-center tw-gap-2.5">
                    <ExecutivesIcon size={16} className={active?.includes("executive-info") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                    Executive Info
                  </div>
                  {isImport && <span className="tw-text-red-500 tw-font-bold tw-text-xs" title="Contains mandatory filters">*</span>}
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("company-info") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["company-info"]);
                  }}
                >
                  <CompanyTypeIcon size={16} className={active?.includes("company-info") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Company Info
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("classification") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["classification"]);
                  }}
                >
                  <ClassificationIcon size={16} className={active?.includes("classification") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Classification
                </div>
              </div>
            </Col>
            <Col
              xs={16}
              className={`tw-p-4 tw-max-h-[400px] tw-overflow-y-auto`}
            >
              {isImport && (
                <>
                  {hasOtherFilters ? (
                    <div>
                      <div className="tw-flex tw-items-center tw-justify-between tw-pb-2">
                        <div className="tw-flex tw-items-center">
                          {Object.entries(allParams).map(([key, value]) => (
                            <Tag
                              key={key}
                              closable
                              onClose={() => onFilterChange(key)}
                              variant="outlined"
                              className="tw-border tw-border-solid tw-py-1 tw-px-2 tw-border-[#C4D7FF] tw-rounded-[20px] tw-bg-[#EEF3FF] tw-text-xs tw-text-sub-text"
                            >
                              {key}:{" "}
                              <span className="tw-text-theme">
                                {formatValue(key, value)}
                              </span>
                            </Tag>
                          ))}
                        </div>
                        <div
                          className="tw-text-[#FF1115] tw-text-xs tw-font-semibold tw-whitespace-nowrap tw-ml-2 tw-cursor-pointer"
                          onClick={() => {
                            const newParams = new URLSearchParams();
                            if (searchParams.get("status")) {
                              newParams.set(
                                "status",
                                searchParams.get("status"),
                              );
                            }

                            navigate(
                              `${location.pathname}?${newParams.toString()}`,
                              { replace: true },
                            );
                          }}
                        >
                          Clear all
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="tw-text-sub-text tw-pb-2">
                      <Filter size={16} className="tw-inline tw-mr-1" /> No filters applied. Select filters from
                      the categories below.
                    </div>
                  )}
                </>
              )}
              <div
                className={`${isImport ? "tw-bg-secondary-color tw-border tw-border-solid tw-rounded-[10px] tw-p-4 tw-border-border-secondary" : ""}`}
              >
                {active?.includes("classification") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(renderMap)
                      .filter(([key]) => ["Saved Search", "Tags"].includes(key))
                      .map(([key, { id, component }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? (
                                <UpIcon size={16} className="tw-text-slate-500" />
                              ) : (
                                <DownIcon size={16} className="tw-text-slate-500" />
                              )
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "classification",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-pl-3">
                                    {key}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div className="filterblk">
                                      {component()}
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                ) : active?.includes("location") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(renderMap)
                      .filter(([key]) =>
                        ["Countries", "States", "Cities"].includes(key),
                      )
                      .map(([key, { id, component }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? (
                                <UpIcon size={16} className="tw-text-slate-500" />
                              ) : (
                                <DownIcon size={16} className="tw-text-slate-500" />
                              )
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "location",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-justify-between tw-w-full tw-pl-3 tw-pr-2">
                                    <span>{key}</span>
                                    {isImport &&
                                    ["Countries", "States", "Cities", "Industry"].includes(key) ? (
                                      <span className="tw-text-red-500 tw-font-bold tw-text-[11px] tw-bg-red-50 tw-px-2 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-red-100">
                                        Required
                                      </span>
                                    ) : null}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div className="filterblk">
                                      {component()}
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                ) : active?.includes("company-info") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(renderMap)
                      .filter(([key]) =>
                        [
                          "Company Type",
                          "Employee Count",
                          "Revenue Range",
                        ].includes(key),
                      )
                      .map(([key, { id, component }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? (
                                <UpIcon size={16} className="tw-text-slate-500" />
                              ) : (
                                <DownIcon size={16} className="tw-text-slate-500" />
                              )
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "company-info",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                                    {key}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div
                                      className="filterblk"
                                      id={id}
                                      key={key}
                                    >
                                      {component()}
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(renderMap)
                      .filter(([key]) =>
                        [
                          "Industry",
                          "Executive Function",
                          "Executive Level",
                        ].includes(key),
                      )
                      .map(([key, { id, component }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? (
                                <UpIcon size={16} className="tw-text-slate-500" />
                              ) : (
                                <DownIcon size={16} className="tw-text-slate-500" />
                              )
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "company-info",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-justify-between tw-w-full tw-pl-3 tw-pr-2">
                                    <span>{key}</span>
                                    {isImport &&
                                    ["Countries", "States", "Cities", "Industry"].includes(key) ? (
                                      <span className="tw-text-red-500 tw-font-bold tw-text-[11px] tw-bg-red-50 tw-px-2 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-red-100">
                                        Required
                                      </span>
                                    ) : null}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div
                                      className="filterblk"
                                      id={id}
                                      key={key}
                                    >
                                      {component()}
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        ) : (
          <div className="tw-p-1 tw-flex tw-flex-col tw-gap-2">
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "location")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("location") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("location")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpIcon size={16} className="tw-text-slate-500" />
                ) : (
                  <DownIcon size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "location",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-justify-between tw-w-full tw-pr-2">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <LocationIcon size={16} className="tw-text-slate-500" />
                        Location
                      </div>
                      {isImport && (
                        <span className="tw-text-red-500 tw-font-bold tw-text-xs">
                          * (Required)
                        </span>
                      )}
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(renderMap)
                        .filter(([key]) =>
                          ["Countries", "States", "Cities"].includes(key),
                        )
                        .map(([key, { id, component }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {component()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "executive-info")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("executive-info") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("executive-info")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpIcon size={16} className="tw-text-slate-500" />
                ) : (
                  <DownIcon size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "executive-info",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-justify-between tw-w-full tw-pr-2">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <ExecutivesIcon size={16} className="tw-text-slate-500" />
                        Executive Information
                      </div>
                      {isImport && (
                        <span className="tw-text-red-500 tw-font-bold tw-text-xs">
                          * (Industry Required)
                        </span>
                      )}
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(renderMap)
                        .filter(([key]) =>
                          [
                            "Industry",
                            "Executive Function",
                            "Executive Level",
                          ].includes(key),
                        )
                        .map(([key, { id, component }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {component()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "company-info")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("company-info") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("company-info")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpIcon size={16} className="tw-text-slate-500" />
                ) : (
                  <DownIcon size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "company-info",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                      <CompanyTypeIcon size={16} className="tw-text-slate-500" />
                      Company Information
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(renderMap)
                        .filter(([key]) =>
                          [
                            "Company Type",
                            "Employee Count",
                            "Revenue Range",
                          ].includes(key),
                        )
                        .map(([key, { id, component }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {component()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "classification")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("classification") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("classification")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpIcon size={16} className="tw-text-slate-500" />
                ) : (
                  <DownIcon size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "classification",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                      <ClassificationIcon size={16} className="tw-text-slate-500" />
                      Classification
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(renderMap)
                        .filter(([key]) =>
                          ["Saved Search", "Tags"].includes(key),
                        )
                        .map(([key, { id, component }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {component()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
          </div>
        )}
      </>
    );
  };

  return <>{renderJsx()}</>;
};

export default AdvancedFilter;
